// @flow

import type {Action} from '../../types'
import type {MapState} from '../types'
import type {SetApiIndexPayload} from '../actions/setApiIndex'

export function setApiIndexReducer(state: MapState, action: Action<SetApiIndexPayload>): MapState {

  return {
    ...state,
    apiIndex: action.payload.apiIndex,
  }
}
